module.exports = __webpack_public_path__ + "static/img/bg-collaboration-with-risis-logo-cr.2fc9d06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingpage/bg-collaboration-with-risis-logo-cr.jpg
// module id = nl5v
// module chunks = 6